import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import NeighbourhoodHeroSection from './components/NeighbourhoodHeroSection';
import GuideSection from './components/GuideSection';
import CallToActionSection from './components/CallToActionSection';

export default function NeighbourhoodGuides() {
  useEffect(() => {
    // Set page-specific meta tags
    document.title = 'Neighbourhood Mortgage Guides | Tony Monteiro';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Explore local mortgage options in Waterloo, Brant County, and Wellington County with expert guidance from licensed mortgage agent Tony Monteiro.');
    }
    
    // Update meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', 'neighbourhood mortgage guides, Waterloo mortgage options, Brant County home loans, Wellington County mortgages, local mortgage broker Ontario, area mortgage expert');
    
    // Set canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://mortgagesforyoubytony.ca/neighbourhood-guides');

    // Add JSON-LD schema
    const existingSchema = document.querySelector('script[type="application/ld+json"]');
    if (existingSchema) {
      existingSchema.remove();
    }
    
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.textContent = '{"@context":"https://schema.org","@graph":[{"@type":"CollectionPage","url":"https://mortgagesforyoubytony.ca/neighbourhood-guides","name":"Neighbourhood Mortgage Guides","about":"Local mortgage guidance for Waterloo, Brant County, and Wellington County.","hasPart":{"@type":"ItemList","itemListElement":[{"@type":"ListItem","position":1,"name":"Waterloo Region","url":"https://mortgagesforyoubytony.ca/neighbourhood-guides#waterloo"},{"@type":"ListItem","position":2,"name":"Brant County","url":"https://mortgagesforyoubytony.ca/neighbourhood-guides#brant"},{"@type":"ListItem","position":3,"name":"Wellington County","url":"https://mortgagesforyoubytony.ca/neighbourhood-guides#wellington"}]}},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://mortgagesforyoubytony.ca/"},{"@type":"ListItem","position":2,"name":"Neighbourhood Guides","item":"https://mortgagesforyoubytony.ca/neighbourhood-guides"}]}]}';
    document.head.appendChild(schemaScript);
  }, []);

  const guideData = [
    {
      region: "Waterloo",
      title: "Waterloo Region Housing Market",
      description: "Discover vibrant communities in the heart of Ontario's technology corridor. Waterloo offers excellent schools, diverse housing options, and a thriving job market. From downtown condos to family homes in established neighbourhoods, find your perfect match for mortgages in Waterloo.",
      highlights: [
        "Top-rated school districts including University of Waterloo",
        "Strong job market in technology and healthcare sectors",
        "Diverse housing from $400K condos to $1M+ family homes",
        "Excellent public transit and highway access",
        "Vibrant downtown core with restaurants and entertainment"
      ],
      imageUrl: "https://public.readdy.ai/ai/img_res/d321f97a14cc90b77ee1be7f7cb74a54.jpg"
    },
    {
      region: "Brant County",
      title: "Brant County Family Communities",
      description: "Experience affordable family living in Brant County's charming communities. Known for excellent value, family-friendly neighborhoods, and strong community spirit. Perfect for first-time buyers and growing families looking for buying a home in Brant County with competitive mortgage rates.",
      highlights: [
        "Affordable housing market with strong appreciation potential",
        "Excellent schools and family recreation facilities",
        "Close proximity to Hamilton and Toronto job markets",
        "Beautiful conservation areas and outdoor activities",
        "Historic downtown areas with local businesses"
      ],
      imageUrl: "https://readdy.ai/api/search-image?query=Charming%20Brant%20County%20Ontario%20residential%20neighborhood%20with%20affordable%20family%20homes%20white%20picket%20fences%20children%20playing%20parks%20nearby%20conservation%20areas%20small%20town%20community%20feel%20professional%20real%20estate%20photography&width=800&height=600&seq=brant-guide&orientation=landscape"
    },
    {
      region: "Wellington County",
      title: "Wellington County Growth Areas",
      description: "Explore the fastest-growing communities in Wellington County. From Guelph's urban amenities to rural lifestyle options, this region offers incredible lifestyle diversity. Ideal for those seeking living in Wellington County with modern conveniences and natural beauty.",
      highlights: [
        "Rapid growth with new developments and infrastructure",
        "Mix of urban amenities and rural lifestyle options",
        "Strong agricultural heritage and local food scene",
        "University of Guelph driving innovation and jobs",
        "Beautiful countryside with recreational opportunities"
      ],
      imageUrl: "https://readdy.ai/api/search-image?query=Wellington%20County%20Ontario%20growing%20suburban%20community%20with%20new%20construction%20homes%20rolling%20hills%20countryside%20views%20University%20of%20Guelph%20in%20distance%20modern%20family%20neighborhoods%20professional%20real%20estate%20photography&width=800&height=600&seq=wellington-guide&orientation=landscape"
    }
  ];

  return (
    <div className="min-h-screen bg-dark-950">
      <Header />
      <main>
        <NeighbourhoodHeroSection />
        
        {/* Guide Sections */}
        {guideData.map((guide, index) => (
          <GuideSection
            key={guide.region}
            region={guide.region}
            title={guide.title}
            description={guide.description}
            highlights={guide.highlights}
            imageUrl={guide.imageUrl}
            reverse={index % 2 === 1}
          />
        ))}
        
        <CallToActionSection />
      </main>
      <Footer />
    </div>
  );
}